import { useTheme } from "@emotion/react";
import React, { Suspense, lazy } from "react";
import FloatingCallButton from "./components/FloatingCallButton ";
import Navbar from "./components/Navbar";
import SuspenseLoader from "./components/SuspenseLoader"; // The custom loader
import { CustomThemeProvider } from "./components/ThemeContext";

// Lazy load components
const HeroSection = lazy(() => import("./components/HeroSection"));
const Services = lazy(() => import("./components/Services"));
const About = lazy(() => import("./components/About"));
const HowWeWork = lazy(() => import("./components/HowWeWork"));
const WhereWeWork = lazy(() => import("./components/WhereWeWork"));
const FAQ = lazy(() => import("./components/FAQ"));
const Contact = lazy(() => import("./components/Contact"));
const ContactForm = lazy(() => import("./components/ContactForm"));
const Footer = lazy(() => import("./components/Footer"));

function App() {
  const theme = useTheme();
  return (
    <CustomThemeProvider theme={theme}>
      <Navbar />

      {/* Suspense will show fallback while lazy-loaded components are being fetched */}
      <Suspense fallback={<SuspenseLoader />}>
        <section id="hero">
          <HeroSection />
        </section>
        <ContactForm />
        <section id="services">
          <Services />
        </section>
        <section id="about">
          <About />
        </section>
        <section id="howwework">
          <HowWeWork />
        </section>
        <section id="wherewework">
          <WhereWeWork />
        </section>
        <section id="faq">
          <FAQ />
        </section>
        <section id="contact">
          <Contact />
        </section>
        <Footer />
      </Suspense>

      <FloatingCallButton />
    </CustomThemeProvider>
  );
}

export default App;
